import React, { useState, useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import linkedin from "../../assets/linkedin.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Contact = () => {
	const form = useRef();
	const [loader, setLoader] = useState(false);

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoader(true);
		try {
			await emailjs.sendForm(
				process.env.REACT_APP_SERVICE_KEY,
				process.env.REACT_APP_TEMPLATE_KEY,
				form.current,
				process.env.REACT_APP_PUBLIC_KEY
			);
			toast.success("Your Email has been Sent!");
		} catch (error) {
			toast.error("Please try Again!");
		}
		setLoader(false);
	};
	return (
		<div className="flex flex-col justify-center items-center pt-28 pb-12 sm:h-full">
		    <ToastContainer />
			<form
				ref={form}
				onSubmit={handleSubmit}
				className="p-10 container w-5/6 sm:w-3/5 object-contain border-2 border-btn rounded-lg flex flex-col items-center gap-4 shadow-2xl px-5 animate-fade-down animate-once animate-duration-400 animate-delay-0 animate-ease-in-out animate-normal animate-fill-both"
			>
				<h1 className="text-4xl font-light text-primary">
					Get in touch!
				</h1>
				<div className="sm:text-lg text-md text-primary text-center">
                      I'm currently open to working on exciting new projects and
                      opportunities, whether part-time, contract, or full-time.
                      Let's bring innovative ideas to life and create
                      exceptional experiences together! 🚀
                    </div>

				<div className="flex sm:flex-row flex-col justify-start items-start w-full sm:gap-10 gap-5">
					<input
						type="text"
						maxLength={25}
						placeholder="Name"
						name="name"
						className="w-full h-12 rounded-lg border-2 border-btn focus:outline-none bg-transparent p-3 text-primary"
						required
					/>
					<input
						type="email"
						name="email"
						placeholder="ahmad@gmail.com"
						className="w-full h-12 rounded-lg border-2 border-btn border-btn focus:outline-none bg-transparent p-3 text-primary"
						required
					/>
				</div>
				<div className="flex sm:flex-row flex-col justify-start items-start w-full sm:gap-10 gap-5">
					<input
						type="tel"
						name="phone"
						placeholder="Phone (Optional)"
						className="w-full h-12 rounded-lg border-2 border-btn border-btn focus:outline-none bg-transparent p-3 text-primary"
					/>
					<div className="w-full hidden sm:block" />
				</div>
				<textarea
					type="text"
					name="message"
					placeholder="Message"
					className="w-full sm:h-[150px] h-[200px] rounded-lg border-2 border-btn border-btn focus:outline-none bg-transparent p-3 text-primary resize-none"
				/>
				<div className="flex justify-center items-center mt-6 gap-10">
					<button
						type="submit"
						className="px-4 py-2 bg-btn hover:opacity-90 border-2 border-btn rounded-full text-white flex justify-center items-center transition-all ease-in-out duration-700"
					>
						{loader ? (
							<div role="status">
								<svg
									ariaHidden="true"
									className="w-6 h-6 text-gray-200 animate-spin  fill-black opacity-30"
									viewBox="0 0 100 101"
									fill="white"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
										fill="white"
									/>
									<path
										d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
										fill="currentFill"
									/>
								</svg>
							</div>
						) : (
							"Send"
						)}
					</button>
					<div className="text-primary opacity-55 flex justify-center items-center">
						/ Message on{" "}
						<a
							rel="noreferrer"
							href="https://www.linkedin.com/in/ahmad-kaleem-1128091b4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
							target="_blank"
							className="rounded-lg transition-all ease-in-out duration-500 ml-2"
						>
							<img
								src={linkedin}
								alt="linkedin"
								className="w-[20px] h-[20px] bg-btn rounded-sm"
							/>
						</a>
					</div>
				</div>
			</form>
		</div>
	);
};

export default Contact;
